import React from 'react';
import { usePathname, useParams } from 'next/navigation';
import { Image } from '@/shared/ui/image';
import { Box } from '@/shared/ui/box';
import { useUser } from '@/shared/providers/user-provider/use-user';
import { useNotifications } from '@/shared/providers/notifications-provider/notifications-context';
import { withBreakpointsSlice } from '@/shared/providers/utils/with-breakpoints-slice';
import { useLocaleFormat } from '@/shared/hooks';
import { useBrandTheme } from '@/shared/hooks';
import { SelectLanguage } from '@/features/select-language';
import { LogoLink } from '../logo-link';

const LogoPart = ({ mobileLandscape }) => {
  const { assets } = useBrandTheme();

  const { user } = useUser();
  const { notifications } = useNotifications();
  const pathname = usePathname();
  const params = useParams();
  const formatUrl = useLocaleFormat();

  const isPlayGame = Boolean(params?.titleGame);
  const isNotMain = pathname !== formatUrl('/');
  const showBonusContent =
    !notifications?.bonus?.isActive && !isPlayGame && mobileLandscape;

  if (showBonusContent) {
    return (
      <Box
        $display="flex"
        $fill
        $justifyContent="space-between"
        $justifyItems="flex-start"
        $alignItems="center"
      >
        <LogoLink isNotMain={isNotMain} formatUrl={formatUrl}>
          <Image
            width="max-content"
            height="max-content"
            style={{ marginTop: '5px' }}
            src={assets.logo.mobile}
            alt="logo"
          />
        </LogoLink>

        {!isNotMain && !user.isAuth && (
          <SelectLanguage alignToLeft={false} isValueMode={true} />
        )}
      </Box>
    );
  }

  if (!mobileLandscape) {
    return (
      <Box
        $display="flex"
        $fill
        $justifyContent="flex-start"
        $alignItems="center"
      >
        <LogoLink isNotMain={isNotMain} formatUrl={formatUrl}>
          <Image
            width="max-content"
            height="max-content"
            src={assets.logo.default}
            alt="logo"
          />
        </LogoLink>
      </Box>
    );
  }

  if (isNotMain && (notifications?.bonus?.isActive || isPlayGame)) {
    return (
      <LogoLink isNotMain={isNotMain} formatUrl={formatUrl}>
        <Image
          width="max-content"
          height="max-content"
          src={assets.logo.mobile}
          alt="logo"
        />
      </LogoLink>
    );
  }

  return null;
};

const LogoPartWithBreakpointsSlice = withBreakpointsSlice(
  LogoPart,
  ({ mobileLandscape, isLandscape, isPortrait }) => ({
    mobileLandscape,
    isLandscape,
    isPortrait,
  })
);

export { LogoPartWithBreakpointsSlice as LogoPart };
